import FileSaver from 'file-saver';
export const stringToCSVFile = (data: string, fileName: string) => {
  FileSaver.saveAs(new Blob([data], { type: 'application/csv' }), `${fileName}.csv`);
};
